module.exports = __webpack_public_path__ + "img/103.5.e103f9c6.png";